import React from "react";
import { Row } from 'react-bootstrap';
import FeatureCounterItem from './featureCounter-item';

function FeatureCounterItems(props) {
  const items = props.featureRowItems;
  const itemsDetails = items.map(( item, index ) =>
    // Correct! Key should be specified inside the array.
    <FeatureCounterItem
      key={ item.icon.toString() }
      value={ item } 
      index={ index }
      />
  );
  
  return (
        <Row>
            {itemsDetails}
        </Row>
  );
}

export default class FeatureCounterRow extends React.Component {
    render() {
        return (
           <FeatureCounterItems featureRowItems={this.props.featureRowItems}/>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/features/featureCounter-row.jsx